// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { headerSignInStyles } from "@synd/Overrides/Widgets/Common/HeaderSignIn";
import { color } from "@synd/XDL/Utilities";
import { css } from "styled-components";

headerSignInStyles.myAccountTooltip = {
    tooltipContent: {
        css: css`
            background-color: ${color("common.white")};
            color: ${color("text")};
            border-radius: 8px;
            padding: 0;
        `,
    },
    drawerInnerContent: {
        css: css`
            padding: 0;
        `,
    },
};

headerSignInStyles.signInTooltip = {
    drawerContent: {
        css: css`
            z-index: ${getProp("theme.zIndex.drawerOverlay")};
        `,
    },
};
